import api from './api'

async function createCalendarEvents (events) {
  const items = Array.isArray(events) ? events : [events]
  return api.post('/calendar', items.length == 1 ? items[0] : items)
}

async function updateCalendarEvent (event) {
  return api.put('/calendar', event)
}

export { createCalendarEvents, updateCalendarEvent }
